var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-check-in-7450807",
    d: "M85.875,89.007l.984-11.545a1.291,1.291,0,0,0,1.161-1.277V67.343a1.285,1.285,0,0,0-1.288-1.277H80.519a1.285,1.285,0,0,0-1.286,1.277v8.843A1.292,1.292,0,0,0,80.4,77.464l.976,11.545a1.113,1.113,0,0,0,1.117,1.025h2.27a1.112,1.112,0,0,0,1.11-1.026ZM72.923,73.462V67.344a1.283,1.283,0,0,0-1.28-1.277H65.424a1.283,1.283,0,0,0-1.28,1.277v6.119H61.082v2.414H78.043V73.462Zm16.288,2.414h1.871V73.462H89.211ZM68.537,60.036a2.521,2.521,0,1,1-2.53,2.525A2.524,2.524,0,0,1,68.537,60.036ZM65.7,81.287h2.042v-.863a1.2,1.2,0,0,1,.207-.672.889.889,0,0,1,.732-.391h3.957a.879.879,0,0,1,.732.391.344.344,0,0,1,.037.06,1.142,1.142,0,0,1,.17.613v.863h2.042a.817.817,0,0,1,.821.812v7.123a.817.817,0,0,1-.821.812l-9.918,0a.811.811,0,0,1-.814-.812V82.1a.811.811,0,0,1,.814-.811Zm3.292,0h3.336v-.68H69Zm5.6,1.254v6.238h-1.25V82.541Zm-6.613,0v6.238h-1.25V82.541Zm15.645-22.5a2.521,2.521,0,1,1-2.522,2.525A2.525,2.525,0,0,1,83.627,60.036Z",
    transform: "translate(-61.082 -60.036)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInToday);
export default __webpack_public_path__ + "static/media/checkInToday.21b39caf3fbb545dcd83cf29fab15f83.svg";
export { ForwardRef as ReactComponent };